document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kg-ugc.ugc-video-section').forEach((section) => {
    initUgcSection(section);
  });
});

function initUgcSection(section) {
  const swiperEl = section.querySelector('.kg-ugc__swiper, .ugc-video-swiper');
  if (!swiperEl || typeof Swiper === 'undefined') return;

  const prevEl = section.querySelector('.kg-ugc__nav-btn--prev, .swiper-button-prev');
  const nextEl = section.querySelector('.kg-ugc__nav-btn--next, .swiper-button-next');

  const mainSwiper = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 25,
    loop: false,
    navigation: {
      nextEl,
      prevEl,
    },
    breakpoints: {
      0: { spaceBetween: 12 },
      750: { spaceBetween: 16 },
      990: { spaceBetween: 25 },
    },
  });

  const modal = section.querySelector('.ugc-modal');
  const closeBtn = section.querySelector('.ugc-close');
  const backdrop = section.querySelector('.ugc-modal-backdrop');
  const slides = [...section.querySelectorAll('.ugc-video-item')];
  let currentIndex = 0;

  if (!modal || !slides.length) return;

  slides.forEach((slide) => {
    const media = slide.querySelector('.kg-ugc__media, .ugc-video-wrap');
    if (!media) return;

    media.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      currentIndex = Number(slide.dataset.index || 0);
      openPopup();
      loadSlideData(currentIndex);
    });
  });

  section.querySelectorAll('.kg-ugc__title, .kg-ugc__buy').forEach((link) => {
    link.addEventListener('click', (e) => e.stopPropagation());
  });

  function getRealSlides() {
    return [...section.querySelectorAll('.ugc-video-item:not(.swiper-slide-duplicate)')];
  }

  function loadSlideData(index) {
    const realSlides = getRealSlides();
    const slide = realSlides[index] || realSlides[0];
    if (!slide) return;

    const videoSrc =
      slide.dataset.video ||
      slide.querySelector('.ugc-video-poster')?.dataset.videoSrc ||
      '';
    const productName = slide.dataset.productName || '';
    const productPrice = slide.dataset.productPrice || '';
    const productImage = slide.dataset.productImage || '';
    const productUrl = slide.dataset.productUrl || '#';

    const popupSlide = modal.querySelector('.ugc-popup-slide');
    const videoContainer = popupSlide.querySelector('.ugc-popup-video-container');
    videoContainer.innerHTML = '';

    if (videoSrc) {
      const video = document.createElement('video');
      video.src = videoSrc;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      videoContainer.appendChild(video);
    }

    popupSlide.querySelector('.prod_title').textContent = productName;
    popupSlide.querySelector('strong').textContent = productPrice;
    popupSlide.querySelector('.ugc-popup-product img').src = productImage;
    popupSlide.querySelector('.ugc-buy').href = productUrl;
  }

  function openPopup() {
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ugc-lock');
  }

  function closePopup() {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ugc-lock');
    const container = modal.querySelector('.ugc-popup-video-container');
    if (container) container.innerHTML = '';
  }

  closeBtn?.addEventListener('click', closePopup);
  backdrop?.addEventListener('click', closePopup);

  modal.querySelector('.ugc-popup-next')?.addEventListener('click', () => {
    const realSlides = getRealSlides();
    currentIndex = (currentIndex + 1) % realSlides.length;
    loadSlideData(currentIndex);
  });

  modal.querySelector('.ugc-popup-prev')?.addEventListener('click', () => {
    const realSlides = getRealSlides();
    currentIndex = (currentIndex - 1 + realSlides.length) % realSlides.length;
    loadSlideData(currentIndex);
  });

  // Keep reference so lint doesn't flag unused in some builds
  void mainSwiper;
}

window.addEventListener('load', () => {
  document.querySelectorAll('.kg-ugc .ugc-video-poster').forEach((poster) => {
    const src = poster.dataset.videoSrc;
    if (!src) return;

    const video = document.createElement('video');
    video.src = src;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('playsinline', '');
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';

    poster.replaceWith(video);
  });
});
